"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountBadge = exports.validCountBadgeColors = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
exports.validCountBadgeColors = [
    'red50',
    'darkTheme.red100',
    'turquoise90',
    'turquoise70',
    'darkTheme.teal100',
    'neutral90',
];
var countBadgeStyles = function (color, borderColor, size, selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* stylelint-disable-next-line */\n  ", ";\n  padding: ", ";\n  border-radius: 24px;\n  /* stylelint-disable-next-line */\n  background-color: ", ";\n  /* stylelint-disable-next-line */\n  color: ", ";\n  border: 1px solid ", ";\n"], ["\n  /* stylelint-disable-next-line */\n  ", ";\n  padding: ", ";\n  border-radius: 24px;\n  /* stylelint-disable-next-line */\n  background-color: ", ";\n  /* stylelint-disable-next-line */\n  color: ", ";\n  border: 1px solid ", ";\n"])), (0, design_system_foundations_1.expandFontTheme)(size === 'lg' ? (0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'body') : (0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'metadata')), size === 'lg' ? '4px 11px' : '2px 7px 3px', (0, design_system_foundations_1.getPrefixedThemeColor)(color), color.startsWith('darkTheme.') ? design_system_foundations_1.darkTheme.color.black : design_system_foundations_1.theme.color.white, borderColor ? design_system_foundations_1.theme.color[borderColor] : 'transparent'); };
exports.CountBadge = (0, react_1.forwardRef)(function (_a, ref) {
    var color = _a.color, count = _a.count, borderColor = _a.borderColor, testId = _a.testId, className = _a.className, _b = _a.size, size = _b === void 0 ? 'sm' : _b, style = _a.style, rest = __rest(_a, ["color", "count", "borderColor", "testId", "className", "size", "style"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    if (!exports.validCountBadgeColors.includes(color)) {
        throw new Error("Invalid badge color, valid colors are ".concat(exports.validCountBadgeColors, " and you passed in ").concat(color, "."));
    }
    if (borderColor && !design_system_foundations_1.theme.color[borderColor]) {
        throw new Error("Invalid borderColor. It must be a valid theme color. Value used was ".concat(borderColor, "."));
    }
    var classes = (0, css_1.cx)(countBadgeStyles(color, borderColor, size, selectedTheme), className, 'ds-count-badge');
    return (react_1.default.createElement("span", __assign({ ref: ref, className: classes, style: style, "data-testid": testId }, rest), count));
});
exports.CountBadge.displayName = 'CountBadge';
var templateObject_1;
